import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Credit-card (Stripe) checkout is temporarily disabled. Flip to true to re-enable
// the card option once live Stripe keys are configured. Backend Stripe code is left intact.
export const CARD_PAYMENTS_ENABLED = false;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const usd = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

// Dev-only diagnostics; production users only see the toast.
export function logError(context, err) {
  if (process.env.NODE_ENV === "development") console.error(context, err); // eslint-disable-line no-console
}

export const newKey = () => `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

export const CAMP_DAYS = [28, 29, 30, 1, 2];
export const CAMP_DAY_LABELS = {
  28: "Jun 28", 29: "Jun 29", 30: "Jun 30", 1: "Jul 1", 2: "Jul 2",
};

export const SCP_LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_camp-checkout-1/artifacts/hfwr3bzi_Sporting_Clube_de_Portugal_2026.svg.png";
export const NC_LOGO = "https://customer-assets-eiarnc6j.emergentagent.net/job_camp-checkout-1/artifacts/w5p8r3c9_nc_logo.png";
export const COMETS_LOGO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_797b2817-54da-4240-9ca7-d69e630c7cf9/artifacts/b74rfu47_73d864_8e32fd4c02fa4f64b8d33df4c8009403~mv2.png";
